import { useAuth } from '../stores/auth.store';
import { BottomNav } from '../components/BottomNav';
import { fmtDateTime } from '../lib/format';

export function ProfilePage() {
  const officer = useAuth((s) => s.officer);
  const logout = useAuth((s) => s.logout);

  return (
    <div className="mx-auto min-h-screen max-w-md bg-gray-50 pb-24">
      <header className="border-b border-gray-200 bg-white p-4">
        <h1 className="text-lg font-bold">โปรไฟล์</h1>
      </header>

      <main className="space-y-4 p-4">
        <div className="card flex items-center gap-3">
          {officer?.linePictureUrl ? (
            <img
              src={officer.linePictureUrl}
              alt=""
              className="h-16 w-16 rounded-full object-cover"
            />
          ) : (
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-200 text-2xl">
              👤
            </div>
          )}
          <div className="min-w-0 flex-1">
            <p className="text-lg font-semibold">
              {officer?.firstName} {officer?.lastName}
            </p>
            <p className="text-xs text-gray-500">{officer?.lineDisplayName}</p>
          </div>
        </div>

        <div className="card space-y-2 text-sm">
          <Row label="สถานะ" value={officer?.status ?? '-'} />
          <Row label="เลขบัตร อปพร." value={officer?.opdCardNo ?? '-'} />
          <Row label="เบอร์โทร" value={officer?.phone ?? '-'} />
          <Row label="อนุมัติเมื่อ" value={fmtDateTime(officer?.approvedAt)} />
          <Row label="สมัครเมื่อ" value={fmtDateTime(officer?.createdAt)} />
        </div>

        <button onClick={logout} className="btn-secondary text-red-600">
          ออกจากระบบ
        </button>
      </main>

      <BottomNav />
    </div>
  );
}

function Row({ label, value }: { label: string; value: string | null | undefined }) {
  return (
    <div className="flex justify-between gap-2">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium">{value || '-'}</span>
    </div>
  );
}
